/**
 * Client-side validation for the create/edit imputation modal on the configuration page.
 */
export function getImputationModalValidationErrors(readLabel, { updatedImputation, isParentMode, subcategories }) {
    const nextErrors = [];
    const categoryTrimmed = String(updatedImputation.category ?? "").trim();
    if (!categoryTrimmed) {
        nextErrors.push(readLabel("imputation_validation_category_required", "Please enter a category name."));
    }
    if (isParentMode && subcategories.length > 0) {
        const hasEmptySubName = subcategories.some((s) => !String(s.category ?? "").trim());
        if (hasEmptySubName) {
            nextErrors.push(readLabel(
                "imputation_validation_subcategory_name_required",
                "Please enter a name for every sub-category."
            ));
        }
    }
    return nextErrors;
}
